module.exports = __webpack_public_path__ + "assets/img/servicesIcon11.2230dc49.svg";